<template>
  <!-- メールテンプレート -->
  <transition name="right">
    <div class="disp-scroll" v-if="isOpenTemplateMenu" style="position: absolute; top: 0; right: 0; height: 100%; width: 40%; min-width: 400px; background: #FEFEFE; padding: 16px; z-index: 201; overflow: auto;">
      <EmailTemplateContents
        :chatbots="chatbots"
        :recordingInterviews="recordingInterviews"
        :users="users"
        :user="user"
        :options="options"
        :emailTemplates="emailTemplates"
        :SMSTemplates="SMSTemplates"
        :createCompanyEmailTemplate="createCompanyEmailTemplate"
        :updateCompanyEmailTemplate="updateCompanyEmailTemplate"
        :deleteCompanyEmailTemplate="deleteCompanyEmailTemplate"
        :createCompanySMSTemplate="createCompanySMSTemplate"
        :updateCompanySMSTemplate="updateCompanySMSTemplate"
        :deleteCompanySMSTemplate="deleteCompanySMSTemplate"
        :copyLink="copyLink"
        :PCTRLLOG="CTRLLOG"
        :saveColumnOrder="saveColumnOrder"
      />
    </div>
  </transition>
</template>

<script>
import EmailTemplateContents from "@/components/organisms/emails/EmailTemplateContents";
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    EmailTemplateContents
  },
  mixins: [
    controlLogMixin
  ],
  data() {
    return {
      modifyTemplateIndex: 0,
      selectBotId: ""
    }
  },
  props: {
    isOpenTemplateMenu: {
      type: Boolean,
      required: true
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    SMSTemplates: {
      type: Array,
      required: true
    },
    createCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    updateCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    deleteCompanyEmailTemplate: {
      type: Function,
      required: true
    },
    createCompanySMSTemplate: {
      type: Function,
      required: true
    },
    updateCompanySMSTemplate: {
      type: Function,
      required: true
    },
    deleteCompanySMSTemplate: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    saveColumnOrder: {
      type: Function,
      required: true
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Manage/EmailTemplate.vue